import AdvUser1 from "../../../assets/images/adv-lucas.png";
import AdvUser2 from "../../../assets/images/adv-angle.png";
import AdvUser3 from "../../../assets/images/adv-jaxson.png";

import LeadUser1 from "../../../assets/images/lead-geehan.png";
import LeadUser2 from "../../../assets/images/lead-artur.png";
import LeadUser3 from "../../../assets/images/lead-xavier.png";
import LeadUser4 from "../../../assets/images/lead-claire.png";
import LeadUser5 from "../../../assets/images/lead-matias.png";
import LeadUser6 from "../../../assets/images/lead-andres.png";
import LeadUser7 from "../../../assets/images/lead-abhishek.png";
import LeadUser8 from "../../../assets/images/lead-pollen.png";
import LeadUser9 from "../../../assets/images/steven.png";

import User1 from "../../../assets/images/user1.png";
import UserCTO from "../../../assets/images/cto.jpg";
import User2 from "../../../assets/images/user2.png";
import User3 from "../../../assets/images/user3.png";
import User4 from "../../../assets/images/user4.png";
import User5 from "../../../assets/images/user5.png";
import User6 from "../../../assets/images/user6.png";

export const precogOversight = {
  advisors: [
    {
      name: "Edward Lucas",
      avatar: AdvUser1,
      title: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra odio sed risus malesuada. `,
      linkedin: null,
    },
    {
      name: "Angel Donin",
      avatar: AdvUser2,
      title: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nisi, neque, imperdiet `,
      linkedin: null,
    },
    {
      name: "Jaxson Gouse",
      avatar: AdvUser3,
      title: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Id sed etiam leo lorem dui.`,
      linkedin: null,
    },
  ],
  leads: [
    {
      name: "Gehan",
      avatar: LeadUser1,
      role: "CEO",
      title: `Extensive leadership and project management experience. Expert in building businesses with a passion for people and the future of finance`,
      linkedin: `https://www.linkedin.com/in/gehan-rajapakse-2813b728`,
    },
    {
      name: "Artur Goulão Ferreira",
      avatar: LeadUser2,
      role: "CTO",
      title: `Founder, Utrust (Switzerland) and Coding Libra (Portugal), partner at Obvious Capital  (London). 5+ years   team management and leadership. `,
      linkedin: `https://www.linkedin.com/in/arturgoulaoferreira/`,
    },
    {
      name: "Xavier Garcia",
      avatar: LeadUser3,
      role: "CMO",
      title: `15 years of experience designing and managing marketing and growth strategies, including 5 years in the crypto/blockchain sphere.Has successfully helped raise 8M$ for crypto icos and helped with the post ico product/token marketing phases. Passionate about defi and crypto.`,
      linkedin: `https://www.linkedin.com/in/fjg20/`,
    },
    {
      name: "Steven Roussanov",
      avatar: LeadUser9,
      role: "CBDO",
      title: `Steven has taken Marketing/BD and Technical roles in electronic finance and algos in equities, forex, and crypto for over 20 years combined. His experience was gained globally in a wide variety of geographies and entities - from bulge-bracket Wall Street banks and major forex brokers, to crypto startups. He is a graduate with highest honors from Columba University in NYC. Fun fact: speaks and writes fluent Chinese.`,
      linkedin: `https://www.linkedin.com/in/steven-roussanov/`,
    },
    {
      name: "Claire Millward",
      avatar: LeadUser4,
      role: "Head of Branding and Communication",
      title: `Head of Marketing for Nomad Now (South Africa’s first end to end hiring platform). Portfolio Head of Marketing for Finka Token (Swiss Security Token) and Portfolio Marketing Consultant for Crypto Valley Journal (Online crypto publication). Yoga and reading enthusiast. `,
      linkedin: `https://www.linkedin.com/in/claire-millward-79626b61/`,
    },
    {
      name: "Matías Molina",
      avatar: LeadUser5,
      role: "Data Scientist",
      title: `PhD in Computer Science with a thesis focused on applied machine learning. Experience as a software developer. Lecturer at National University of Córdoba.  Enjoys finding social spaces to propose and discuss different approaches, to solve given problems. `,
      linkedin: `https://www.linkedin.com/in/matiasmolina/`,
    },
    {
      name: "Andres Maes",
      avatar: LeadUser6,
      role: "Algorithm Engineer",
      title: `Masters in Computer Science. Passion for algorithms and AI. Andres spends his free time fiddling around with code, and learning new things. He loves to use algorithms and AI to solve real world problems, instead of “neatly defined” problems. `,
      linkedin: `https://www.linkedin.com/in/andres-maes-2566221b9/`,
    },
    {
      name: "Abhishek G",
      avatar: LeadUser7,
      role: "Financial Engineer",
      title: `Dual Masters in Financial Engineering and Business Administration from the prestigious IIT (Delhi). Seasoned consultant, with over a decade of experience in providing advisory services for mathematical and quantitative research of financial products and markets. `,
      linkedin: null,
    },
    {
      name: "Pollen Chakma",
      avatar: LeadUser8,
      role: "Head of UX / UI ",
      title: `Founder, eetpixel creative agency, specialising in interactive design and cutting-edge technology. 6+ years in the field. Dedicated to staying up to date on new design trends and techniques. Expert in converting crazy ideas into the visual language! Loves to explore cutting-edge technologies. `,
      linkedin: "https://www.linkedin.com/in/pollen-c-587a23ab/",
    },
  ],
};

export const data = [
  {
    avatar: User1,
    name: "Gehan",
    title: "Director operations",
    link: "https://www.linkedin.com/in/gehan-rajapakse-2813b728",
  },
  {
    avatar: UserCTO,
    name: "Artur Goulão Ferreira",
    title: "CTO",
    link: "https://www.linkedin.com/in/arturgoulaoferreira/",
  },
  {
    avatar: User2,
    name: "Matías Molina ",
    title: "Phd applied computer science",
    link: "https://www.linkedin.com/in/matiasmolina/",
  },
  {
    avatar: User3,
    name: "Abhishek G",
    title: "Quant, MBA, Masters in financial engineering",
    link: null,
  },
  {
    avatar: User4,
    name: "Andres Maes",
    title: "M.Eng Algorithm engineer",
    link: "https://www.linkedin.com/in/andres-maes-2566221b9/",
  },
  {
    avatar: User5,
    name: "Claire Millward",
    title: "BA, head of digital strategy",
    link: "https://www.linkedin.com/in/claire-millward-490519166/",
  },
  {
    avatar: User6,
    name: "Xavier Garcia",
    title: "Growth expert, Chief marketing officer",
    link: "https://www.linkedin.com/in/fjg20/",
  },
];
